import { Injectable } from '@angular/core'
import { MediaUpdate } from 'elements-sdk'
import { IdentityService } from 'main/services/identity.service'
import { UserStorageService } from 'common/util/services/sharedStorage.service'
import { SocketService } from 'common/util/services/socket.service'
import { APIService } from 'api/services/api.service'

@Injectable({ providedIn: 'root' })
export class MediaUpdatesTrackerService {
  KEY = 'lastViewedMediaUpdateID'
  lastViewedMediaUpdateID: number
  newestUpdateID: number

  constructor (
    private api: APIService,
    private identity: IdentityService,
    private userStorage: UserStorageService,
    private socket: SocketService,
  ) {
    if (!identity.loggedIn) {
      return
    }

    this.lastViewedMediaUpdateID = userStorage.get(this.KEY) || -1
    this.refresh()
    socket.subject('media:update-created').subscribe(() => this.refresh())
  }

  async refresh (): Promise<void> {
    if (!this.identity.hasPermission('media:access')) {
      return
    }
    let latestUpdate: MediaUpdate|null = null
    try {
      latestUpdate = await this.api.mediaLibrary.getLatestMediaUpdate({})
    } catch (e) {
      return
    }

    if (latestUpdate.id) {
      this.newestUpdateID = latestUpdate.id
      if (!this.lastViewedMediaUpdateID) {
        this.lastViewedMediaUpdateID = this.newestUpdateID
        await this.userStorage.querySet(this.KEY, this.lastViewedMediaUpdateID)
      }
    }
  }

  newUpdatesCount (): number {
    return Math.max(0, this.newestUpdateID - this.lastViewedMediaUpdateID)
  }

  async markViewed (): Promise<void> {
    await this.refresh()
    if (!this.newestUpdateID || this.lastViewedMediaUpdateID === this.newestUpdateID) {
      return
    }
    this.lastViewedMediaUpdateID = this.newestUpdateID
    await this.userStorage.querySet(this.KEY, this.lastViewedMediaUpdateID || -1)
  }
}
